import { Button, ButtonProps } from '@/components/ui/button';
import useEditorStore from '@/state/editor-store';
import useGeneratorStore from '@/state/generator-store';
import React from 'react';
import { useWatch } from 'react-hook-form';
import styles from './index.module.scss';
import TrackControl from './TrackControl';
import { useCredit } from './useCredit';

interface GenerateButtonProps extends ButtonProps {
  disabled: boolean;
}

const GenerateButton: React.FC<GenerateButtonProps> = ({ disabled, ...props }) => {
  const { control, generatorType, isGeneratorDrawerShow, tracksCount, setTracksCount } = useGeneratorStore();
  const { operator, duration: editorDuration } = useEditorStore();

  const duration = useWatch({
    control,
    name: 'duration',
    defaultValue: 0,
  });

  const credit = useCredit({ duration, operator, editorDuration, isGeneratorDrawerShow, generatorType, tracksCount });

  return (
    <Button
      className={`${styles.generatorButtonBg} flex flex-col w-full h-full p-4 text-lg text-accent-foreground rounded-none`}
      disabled={disabled}
      size="full"
      {...props}
    >
      <div className={`${styles.generatorButton} relative w-full h-full flex justify-between rounded-[20px]`}>
        <div className="flex items-center justify-start px-4 w-[calc(100%-60px)] pointer-events-none">
          <div className="flex flex-col">
            <div className="flex items-baseline">
              <span className="flex items-center font-inter text-[1.4rem] ml-3 font-medium leading-[24px] tracking-[-0.02em] text-left text-white">
                Jenerate
                <span className="text-white text-[0.7rem] font-normal font-['NB International Pro'] ml-1.5 mt-[-0.6rem]">{credit} CRD</span>
              </span>
            </div>
          </div>
        </div>

        <TrackControl />
      </div>
    </Button>
  );
};

export default GenerateButton;
